import { LocationVarKey } from "@swivl-mono/types";

import { IF_ANY, IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.VoiceAutopayMessage,
  LocationVarKey.VoiceSendAutopayText,
  LocationVarKey.VoiceAutopayTextMessage,
  LocationVarKey.VoiceForwardAutopay,
  LocationVarKey.VoiceAutopayEscalateTo,
  LocationVarKey.VoiceAutopayPhoneNumber
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page}>Autopay</PageHeader>
      <TextAreaRow {...page} marginTop label=" Voice Message" keyName={LocationVarKey.VoiceAutopayMessage} />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceSendAutopayText} label="Send SMS" />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.VoiceSendAutopayText, "1")}
        marginTop
        label=" SMS Message"
        keyName={LocationVarKey.VoiceAutopayTextMessage}
      />
      <SwitchRow {...page} keyName={LocationVarKey.VoiceForwardAutopay} label="Escalate" />
      <DropdownRow
        {...page}
        hideIf={IS_EQUAL(LocationVarKey.VoiceForwardAutopay, "0")}
        label="Send escalations to"
        marginTop
        keyName={LocationVarKey.VoiceAutopayEscalateTo}
        options={[
          { label: "swivl Conversations", value: "swivl" },
          { label: "External Phone Number", value: "phone" }
        ]}
      />
      <Section
        {...page}
        hideIf={IF_ANY([IS_NOT_EQUAL(LocationVarKey.VoiceForwardAutopay, "1"), IS_EQUAL(LocationVarKey.VoiceAutopayEscalateTo, "swivl")])}
      >
        <InputRow {...page} keyName={LocationVarKey.VoiceAutopayPhoneNumber} label="External Phone Number" />
        <div className="cortexDescription">
          This is the direct line defined{" "}
          <a
            href="/properties/page/cortex/voice/voice-settings"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#FF5B02", textDecoration: "underline" }}
          >
            here
          </a>
          . Only overwrite this if you have a different direct line for this use case!
        </div>
      </Section>
    </>
  );
}
